import { DateUtils } from '@vectord/utils';

import toStartOfUTCDay from './toStartOfUTCDay';

function getUTCMinuteOfDay(d) {
  const date = new Date(d);
  const startOfDay = toStartOfUTCDay(date);

  return Math.floor(
    (date.getTime() - startOfDay.getTime()) / DateUtils.ONE_MINUTE
  );
}

export default getUTCMinuteOfDay;
